export default {
    previewPopup: {
        closeBtn: 'Fechar',
        followBtn: 'Seguir',
        touchBtn: 'Não Exibir Novamente',
    },
}
